<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--診間診號查詢-->
    <v-flex row wrap xs12 sm12 md12 lg12 ml-2 mr-2 :style="{marginBottom:$vuetify.breakpoint.smAndDown?'56px':'auto'}">

        <v-flex class="text-center">
            <v-progress-linear v-show="isLoading" :indeterminate="isLoading"></v-progress-linear> <!--載入進度條 -->
        </v-flex>

        <v-flex class="xs12 sm12 md12 lg12 ml-0 mt-1">
            <v-flex class="xs12 sm12 md9 lg9">
                <v-flex :style="{textAlign:$vuetify.breakpoint.smAndDown?'right':'right'}">

                    <!-- <v-btn title="重新整理" text  light @click.native="axios_getClinicNoList('0')" style="vertical-align: inherit;">
                        <v-icon>mdi-reload</v-icon>重新整理
                    </v-btn> -->

                </v-flex>

                <v-row>
                    <v-col cols="12" sm="12" md="5" :class="['clinicNoTitle',$vuetify.breakpoint.smAndDown?'text-center':'text-right']"  style="margin-top: -18px">
                        <v-radio-group  v-model="apnRadio"  row hide-details @change="clickApn" >
                            <v-radio  value='1' >
                                <template v-slot:label>
                                   <div class="clinicNoTitle" >上午</div>
                                </template>
                            </v-radio>
                            <v-radio label="下午" value='2' >
                                <template v-slot:label>
                                    <div class="clinicNoTitle" >下午</div>
                                </template>
                            </v-radio>
                            <v-radio label="晚上" value='3' >
                                <template v-slot:label>
                                    <div class="clinicNoTitle" >晚上</div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" sm="12" md="7" :class="[$vuetify.breakpoint.smAndDown?'text-center':'text-left', 'clinicNoTitle']">
                        <v-row>
                            <v-flex class="xs12 sm12 md9 lg9">
                                [{{zoneName}}] <br>  
                                {{apnTitle}}   {{this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date')}}目前看診號
                            </v-flex>

                            <v-flex class="xs12 sm12 md3 lg3 text-right">
                                <v-btn  title="重新整理" text  light @click.native="axios_getClinicNoList('0')" style="vertical-align: inherit;text-align:right!imporant">
                                    <v-icon>mdi-reload</v-icon>重新整理
                                </v-btn>
                            </v-flex>
                        </v-row>

                    </v-col>

                </v-row>

            </v-flex>

            <!-- <v-flex ></v-flex> -->

            <v-row>
                <v-flex class="xs12 sm12 md9 lg9 ">
                    <table style="width: 100%" class="clinicTableOutline  elevation-1 clincnosearch-tableoutline-weihao">
                        <thead class="clinicNoThead">
                        <tr>
                            <th class="clinicNoTh clincnosearch-clincNoTh-weihao">科別名稱</th>
                            <th class="clinicNoTh clincnosearch-clincNoTh-weihao">診間</th>
                            <th class="clinicNoTh clincnosearch-clincNoTh-weihao">醫師</th>
                            <th class="clinicNoTh clincnosearch-clincNoTh-weihao">診號</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template>
                            <tr   v-for="(item,index) in clinicNoList" :key="index" class="clinicnosearch-tr-weihao">
                                <td :class="['text-center', index%2==0?'clinicNoTdOdd clinicnosearch-clinicNoTdOdd-weihao':'clinicNoTd clinicnosearch-clinicTdOdd-weihao']">
                                    <v-flex class="clinicNoTdDiv clinicnosearch-clinicNoTdDiv-weihao">
                                        {{item.divName}}
                                    </v-flex>
                                </td>
                                <td :class="['text-center', index%2==0?'clinicNoTdOdd clinicnosearch-clinicNoTdOdd-weihao':'clinicNoTd clinicnosearch-clinicTdOdd-weihao']">
                                    <v-flex class="clinicNoTdDiv clinicnosearch-clinicNoTdDiv-weihao">
                                        {{item.clinicName}}
                                    </v-flex>
                                </td>
                                <td :class="['text-center', index%2==0?'clinicNoTdOdd clinicnosearch-clinicNoTdOdd-weihao':'clinicNoTd clinicnosearch-clinicTdOdd-weihao']">
                                    <v-flex class="clinicNoTdDiv clinicnosearch-clinicNoTdDiv-weihao">
                                        {{item.doctorName}}
                                    </v-flex>
                                </td>
                                <td :class="['text-center', index%2==0?'clinicNoTdOdd clinicnosearch-clinicNoTdOdd-weihao':'clinicNoTd clinicnosearch-clinicTdOdd-weihao']">
                                    <v-flex class="clinicNoTdDivLast clinicnosearch-clinicNoTdDivLast-weihao">
                                        {{item.nowViewNo}}
                                    </v-flex>

                                </td>
                            </tr>
                        </template>

                        </tbody>
                    </table>

                    <v-flex class="text-right mt-1">
                        <span> 最近更新時間:{{updateTime}} </span>
                    </v-flex>

                </v-flex>
                <v-flex class="xs12 sm12 md3 lg3 ">
                    <p style="font-size: 1.2rem" :style="$vuetify.breakpoint.smAndDown?'':'margin-top:-70px'" :class="$vuetify.breakpoint.smAndDown?'pl-1':'pl-10'"  v-html="regNote"></p>
                    
                </v-flex>

            </v-row>




        </v-flex>

        <!-- <v-flex class="xs12 sm12 md3 lg2 pl-1 mt-1">
        </v-flex> -->

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>

    </v-flex>
</template>

<script>
    export default {
        name: "ClinicNoSearch",
        created(){
           this.axios_getClinicNoList('0');
           this.axios_getZoneName();
           this.axios_getRegNote();
        },
        data() {
            return {
                zoneName:'',
                apnRadio:0,
                clinicNoList: [],
                isLoading:false,
                snTimeout:4000,
                snStatus:false,
                snText:'',
                updateTime:'',
                apnTitle:'',
                timers:null,
                regNote:"",
            }
        },
        destroyed(){
            clearTimeout(this.timers); //要記得先清除實例 再call API
        },
        beforeDestroy(){
            clearTimeout(this.timers); //要記得先清除實例 再call API
        },
        watch: {
            '$route.params': function () {
                this.axios_getClinicNoList('0');
                this.axios_getZoneName();
            },
        },
        methods:{
            clickApn(val){
                this.axios_getClinicNoList(val);
            },
            transApn(apn){
                this.apnTitle = '';
                switch (apn){
                    case 1:
                        this.apnTitle = '上午'
                        break;
                    case 2:
                        this.apnTitle = '下午'
                        break;
                    case 3:
                        this.apnTitle = '晚上'
                        break;
                    default:
                }
            },
            axios_getClinicNoList (apn){ //取得目前診間診號
                clearTimeout(this.timers); //要記得先清除實例 再call API
                this.clinicNoList = [];
                this.isLoading = true;
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "clinicparam/byzoneapn/"+zone+"/"+apn;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0&&response.data.status=="INFO"){
                        this.clinicNoList = response.data.resultSet
                        this.isLoading = false;
                        this.updateTime = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'all');
                        this.transApn(this.clinicNoList[0].apn);
                        this.apnRadio = this.clinicNoList[0].apn.toString();
                    }else{
                        this.clinicNoList = [];
                        this.isLoading = false;
                    }

                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.clinicNoList = [];
                        this.isLoading = false;
                    } catch(err) {
                        this.clinicNoList = [];
                        this.isLoading = false;
                    }
                });
                let that = this;
                this.timers =    setTimeout(function(){ that.axios_getClinicNoList(apn); }, 60000);

            },

            axios_getZoneName (){  //查詢院區名稱
                this.zoneName = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/"+zone;
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneName = response.data.resultSet[0].zoneName;
                    }else{
                        this.zoneName ='';
                    }
                }).catch(error =>  {
                    this.zoneName = '';
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },

            axios_getRegNote (){ //看診進度說明
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/VIEWNO/ALL";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.regNote+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                    } catch(err) {
                        console.log(err.response.data.status);
                    }
                });
            },

        }
    }
</script>

<style scoped>







</style>